<template>
	<pre v-html="prettyJSON(json)"></pre>
</template>

<script>
	export default {
		name: "PrettyJSON",

		props: {
			json: {
				default: () => {}
			}
		},
		methods: {
			/* eslint-disable */
			prettyJSON (json) {
				if (json) {
					json = JSON.stringify(json, undefined, 4);
					json = json.replace(/&/g, '&').replace(/</g, '<').replace(/>/g, '>');
					return json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, function(match) {
						var cls = 'number';
						if (/^"/.test(match)) {
							if (/:$/.test(match)) {
								cls = 'key';
							} else {
								cls = 'string';
							}
						} else if (/true|false/.test(match)) {
							cls = 'boolean';
						} else if (/null/.test(match)) {
							cls = 'null';
						}
						return '<span class="' + cls + '">' + match + '</span>';
					});
				}
			},
		}
	};
</script>

<style scoped>

</style>